module.exports = __webpack_public_path__ + "static/img/home.a578783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/software/wxMini/home.jpg
// module id = tTdt
// module chunks = 0